// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-page {
  background-color: rgb(247, 248, 249) !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  background-color: #e4e6eb !important;
}
.form-page .headers-home {
  width: 100%;
  z-index: 10;
  padding: 0px !important;
  margin: 0px !important;
}
.form-page .homePage-navbar {
  margin-top: 1rem;
}
.form-page .logged-navbar {
  margin-bottom: 20px !important;
  position: sticky;
  top: 0;
  padding: 0px !important;
  z-index: 10;
}
.form-page .dropdowns-containers-navbar {
  padding: 0px !important;
  margin: 0px !important;
  width: 100% !important;
}
.form-page .row-box-container {
  background-color: rgb(228, 230, 235);
  padding: 0px !important;
  margin: 0px !important;
  height: 100vh !important;
}
.form-page .request-container-page {
  background-color: #e4e6eb;
  min-height: 90vh !important;
  justify-content: flex-start;
  height: 100vh;
  padding-left: 0;
}
.form-page .box-menu {
  margin-left: 18px;
  align-self: flex-start !important;
  justify-content: flex-start !important;
}

.item-col {
  margin-top: 10px !important;
}

.form-container-row {
  background-color: #e4e6eb;
  justify-content: center;
  align-self: center;
  width: 100%;
}

.box-data-important {
  background-color: rgb(255, 255, 255);
  height: 40vh;
  overflow: auto !important;
  position: sticky !important;
  top: 20px;
  margin-bottom: 10px;
  padding: 15px;
  justify-content: flex-start !important;
}

.forminputs-data-important {
  justify-content: center !important;
  align-items: center !important;
  align-content: center !important;
  align-self: center !important;
  padding: 10px;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}

.text-claim-box {
  overflow: auto !important;
  align-self: flex-start !important;
}

.form-container-claim {
  align-self: center !important;
  justify-content: center !important;
  align-items: center !important;
  align-content: center !important;
}

.item-form {
  margin-top: 25px;
  align-self: center !important;
  justify-content: center !important;
  align-items: center !important;
  align-content: center !important;
}

.row-attachFiles {
  width: 100%;
  margin: 0 !important;
}

h5 {
  padding: 0px !important;
}

.style-btn-2 {
  background-color: #8f033c !important;
  color: rgb(255, 255, 255) !important;
  width: 140px;
  padding: 15px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
  align-self: flex-end !important;
}

.btn-cancel-coi {
  height: 3rem;
  margin-top: 10px !important;
  margin-right: 0 !important;
}

.col-button-submit {
  align-self: flex-end;
  justify-content: flex-end !important;
  align-items: flex-end !important;
  align-content: flex-end;
  display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;
}

.style-btn-1 {
  background-color: rgb(237, 236, 235) !important;
  color: black !important;
  width: 140px !important;
  padding: 10px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
}

.group-bottom-claim {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  margin-right: 20px;
}

.title-claim {
  font-size: 12px !important;
  font-family: "Lato", sans-serif !important;
}

.body-claim {
  font-size: 11px !important;
  font-family: "Lato", sans-serif !important;
}

li {
  font-size: 11px !important;
  font-family: "Lato", sans-serif !important !important;
}

.icon-file {
  align-self: center !important;
  text-align: center !important;
  margin: 0px 10px !important;
}

.limit-files {
  align-self: center !important;
  text-align: center !important;
  margin: 0px 0px !important;
}

@media screen and (max-width: 768px) {
  .col-button-submit {
    margin-top: 20px !important;
  }
  .box-data-important {
    height: 100%;
  }
}
@media screen and (max-width: 992px) {
  .box-data-important {
    height: 100%;
  }
}
input[type=file] {
  display: none;
}

.custom-file-upload-is-invalid {
  background-color: rgb(255, 255, 255);
  margin-left: 0;
  margin-right: 0;
  border-radius: 5px;
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: block;
  padding: 6px 12px;
  cursor: pointer;
  padding-right: calc(1.5em + 0.75rem) !important;
  border-color: #dc3545;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.custom-file-upload {
  background-color: rgb(255, 255, 255);
  margin-left: 0;
  margin-right: 0;
  border-radius: 5px;
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: block;
  padding: 6px 12px;
  cursor: pointer;
}

.col-button-submit .style-btn-1 {
  flex: 0 0 auto;
  width: auto !important;
  min-width: 110px;
  max-width: 38%;
}

.col-button-submit .style-btn-2 {
  flex: 1 1 auto;
  width: auto;
  min-width: 150px;
  max-width: 60%;
}

.invalid-feedback-file {
  color: #dc3545;
  font-size: 80% !important;
}

.tooltip-empty {
  display: none !important;
}

.btn-delete-it {
  background-color: #8f033c !important;
  color: rgb(255, 255, 255) !important;
  width: 140px;
  padding: 15px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
  align-self: flex-end !important;
}

.btn-cancel-it {
  background-color: rgb(238, 238, 238) !important;
  color: black !important;
  width: 140px;
  padding: 15px !important;
  font-size: 10px !important;
  font-family: "Lato", sans-serif !important;
  align-self: flex-end !important;
}

.file-clear {
  color: #8f033c;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/requestcoi/requestcoi.scss","webpack://./src/sass/utilities/_mixins.scss","webpack://./src/sass/layout/requestcoi/requestcoi.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;ECME,+CAAA;EACA,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EDRA,oCAAA;AEEF;AFDE;EACE,WAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;AEGJ;AFDE;EACE,gBAAA;AEGJ;AFDE;EACE,8BAAA;EACA,gBAAA;EACA,MAAA;EACA,uBAAA;EACA,WAAA;AEGJ;AFDE;EACE,uBAAA;EACA,sBAAA;EACA,sBAAA;AEGJ;AFDE;EACE,oCAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;AEGJ;AFAE;EACE,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;AEEJ;AFCE;EACE,iBAAA;EACA,iCAAA;EACA,sCAAA;AECJ;;AFGA;EACE,2BAAA;AEAF;;AFGA;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AEAF;;AFGA;EACE,oCGpDM;EHqDN,YAAA;EACA,yBAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,sCAAA;AEAF;;AFGA;EACE,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,6BAAA;EACA,8BAAA;AEAF;;AFGA;EACE,yBAAA;EACA,iCAAA;AEAF;;AFGA;EACE,6BAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;AEAF;;AFGA;EACE,gBAAA;EACA,6BAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;AEAF;;AFGA;EACE,WAAA;EEAF,oBAAA;AACA;;AAEA;EFEE,uBAAA;AEAF;;AAEA;EFEE,oCAAA;EACA,oCAAA;EEAF,YAAA;EACE,wBAAwB;EFC1B,0BAAA;EACE,0CAAA;EACA,+BAAA;AECF;;AAEA;EFAA,YAAA;EACE,2BAAA;EACA,0BAAA;AEEF;;AAEA;EACA,oBAAA;EACE,oCAAoC;EFAtC,gCAAA;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AEEF;;AAEA;EFAA,+CAAA;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,0CAAA;AEEF;;AFCA;EACE,aAAA;EACA,mBAAA;EEEF,yBAAA;EACE,gBAAgB;EFClB,kBAAA;AECA;;AAEA;EACE,0BAA0B;EFC5B,0CAAA;AECA;;AAEA;EACE,0BAA0B;EFC5B,0CAAA;AECA;;AAEA;EACA,0BAAA;EACE,qDAAqD;AFCvD;;AEEA;EFCE,6BAAA;EECF,6BAAA;EACE,2BAA2B;AFC7B;;AEEA;EACE,6BAAA;EFCA,6BAAA;EECA,0BFAE;AECJ;;AFGA;EACE;IACE,2BAAA;EEAF;EACF;IFGA,YAAA;EACE;AEDF;AACA;EFGA;IACE,YAAA;EACA;AEDF;AACA;EFGE,aAAA;AEDF;;AAEA;EFGE,oCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;EEDF,sBAAA;EACE,cAAc;EFGhB,iBAAA;EACE,eAAA;EACA,+CAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AEDF;;AAEA;EACE,oCAAoC;EFGtC,cAAA;EACE,eAAA;EACA,kBAAA;EEDF,sBAAA;EACE,eAAe;EFGjB,sBAAA;EACE,sBAAA;EEDF,cAAA;EACE,iBAAiB;EFEnB,eAAA;AEAA;;AAEA;EFEE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AEAF;;AFEA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AECF;;AAEA;EACA,cAAA;EACE,yBAAyB;AFC3B;;AEEA;EACA,wBAAA;AACA;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,YAAY;EACZ,wBAAwB;EACxB,0BAA0B;EAC1B,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,0BAA0B;EAC1B,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.form-page {\n  @include settingsPage();\n  background-color: #e4e6eb !important;\n  .headers-home {\n    width: 100%;\n    z-index: 10;\n    padding: 0px !important;\n    margin: 0px !important;\n  }\n  .homePage-navbar {\n    margin-top: 1rem;\n  }\n  .logged-navbar {\n    margin-bottom: 20px !important;\n    position: sticky;\n    top: 0;\n    padding: 0px !important;\n    z-index: 10;\n  }\n  .dropdowns-containers-navbar {\n    padding: 0px !important;\n    margin: 0px !important;\n    width: 100% !important;\n  }\n  .row-box-container {\n    background-color: rgb(228 230 235);\n    padding: 0px !important;\n    margin: 0px !important;\n    height: 100vh !important;\n  }\n\n  .request-container-page {\n    background-color: #e4e6eb;\n    min-height: 90vh !important;\n    justify-content: flex-start;\n    height: 100vh;\n    padding-left: 0;\n  }\n\n  .box-menu {\n    margin-left: 18px;\n    align-self: flex-start !important;\n    justify-content: flex-start !important;\n  }\n}\n\n.item-col {\n  margin-top: 10px !important;\n}\n\n.form-container-row {\n  background-color: #e4e6eb;\n  justify-content: center;\n  align-self: center;\n  width: 100%\n}\n\n.box-data-important {\n  background-color: $White;\n  height: calc(40vh);\n  overflow: auto !important;\n  position: sticky !important;\n  top: 20px;\n  margin-bottom: 10px;\n  padding: 15px;\n  justify-content: flex-start !important;\n}\n\n.forminputs-data-important {\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n  align-self: center !important;\n  padding: 10px;\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n\n.text-claim-box {\n  overflow: auto !important;\n  align-self: flex-start !important;\n}\n\n.form-container-claim {\n  align-self: center !important;\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.item-form {\n  margin-top: 25px;\n  align-self: center !important;\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.row-attachFiles {\n  width: 100%;\n  margin: 0 !important;\n}\n\nh5 {\n  padding: 0px !important;\n}\n\n.style-btn-2 {\n  background-color: #8f033c !important;\n  color: $White !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n  align-self: flex-end !important;\n}\n.btn-cancel-coi {\n  height: 3rem;\n  margin-top: 10px !important;\n  margin-right: 0 !important;\n}\n.col-button-submit {\n  align-self: flex-end;\n  justify-content: flex-end !important;\n  align-items: flex-end !important;\n  align-content: flex-end;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 12px;\n  width: 100%;\n}\n\n.style-btn-1 {\n  background-color: rgba(237, 236, 235, 1) !important;\n  color: black !important;\n  width: 140px !important;\n  padding: 10px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n}\n\n.group-bottom-claim {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  margin-right: 20px;\n}\n\n.title-claim {\n  font-size: 12px !important;\n  font-family: $Font;\n  // padding-top: 100px;\n}\n\n.body-claim {\n  font-size: 11px !important;\n  font-family: $Font;\n}\n\nli {\n  font-size: 11px !important;\n  font-family: $Font !important;\n}\n\n.icon-file {\n  align-self: center !important;\n  text-align: center !important;\n  margin: 0px 10px !important;\n}\n\n.limit-files {\n  align-self: center !important;\n  text-align: center !important;\n  margin: 0px 0px !important;\n}\n\n@media screen and (max-width: 768px) {\n  .col-button-submit {\n    margin-top: 20px !important;\n  }\n  .box-data-important {\n    height: 100%;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .box-data-important {\n    height: 100%;\n  }\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\n.custom-file-upload-is-invalid {\n  background-color: $White;\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  border-color: #dc3545;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.custom-file-upload {\n  background-color: $White;\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.col-button-submit .style-btn-1 {\n  flex: 0 0 auto;\n  width: auto !important;\n  min-width: 110px;\n  max-width: 38%;\n}\n\n.col-button-submit .style-btn-2 {\n  flex: 1 1 auto;\n  width: auto;\n  min-width: 150px;\n  max-width: 60%;\n}\n\n.invalid-feedback-file {\n  color: #dc3545;\n  font-size: 80% !important;\n}\n\n.tooltip-empty {\n  display: none !important;\n}\n.btn-delete-it {\n  background-color: #8f033c !important;\n  color: $White !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n  align-self: flex-end !important;\n}\n.btn-cancel-it {\n  background-color: rgb(238, 238, 238) !important;\n  color: black !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: $Font;\n  align-self: flex-end !important;\n}\n\n.file-clear {\n  color: #8f033c;\n  cursor: pointer;\n}","@import \"./variables\";\n\n@mixin flexCenter($justify-content, $align-items) {\n  display: flex;\n  justify-content: $justify-content;\n  align-items: $align-items;\n}\n\n@mixin settingsPage() {\n  background-color: $MainBackgroundColor !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n",".form-page {\n  background-color: rgb(247, 248, 249) !important;\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n  background-color: #e4e6eb !important;\n}\n.form-page .headers-home {\n  width: 100%;\n  z-index: 10;\n  padding: 0px !important;\n  margin: 0px !important;\n}\n.form-page .homePage-navbar {\n  margin-top: 1rem;\n}\n.form-page .logged-navbar {\n  margin-bottom: 20px !important;\n  position: sticky;\n  top: 0;\n  padding: 0px !important;\n  z-index: 10;\n}\n.form-page .dropdowns-containers-navbar {\n  padding: 0px !important;\n  margin: 0px !important;\n  width: 100% !important;\n}\n.form-page .row-box-container {\n  background-color: rgb(228, 230, 235);\n  padding: 0px !important;\n  margin: 0px !important;\n  height: 100vh !important;\n}\n.form-page .request-container-page {\n  background-color: #e4e6eb;\n  min-height: 90vh !important;\n  justify-content: flex-start;\n  height: 100vh;\n  padding-left: 0;\n}\n.form-page .box-menu {\n  margin-left: 18px;\n  align-self: flex-start !important;\n  justify-content: flex-start !important;\n}\n\n.item-col {\n  margin-top: 10px !important;\n}\n\n.form-container-row {\n  background-color: #e4e6eb;\n  justify-content: center;\n  align-self: center;\n  width: 100%;\n}\n\n.box-data-important {\n  background-color: rgb(255, 255, 255);\n  height: 40vh;\n  overflow: auto !important;\n  position: sticky !important;\n  top: 20px;\n  margin-bottom: 10px;\n  padding: 15px;\n  justify-content: flex-start !important;\n}\n\n.forminputs-data-important {\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n  align-self: center !important;\n  padding: 10px;\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n\n.text-claim-box {\n  overflow: auto !important;\n  align-self: flex-start !important;\n}\n\n.form-container-claim {\n  align-self: center !important;\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.item-form {\n  margin-top: 25px;\n  align-self: center !important;\n  justify-content: center !important;\n  align-items: center !important;\n  align-content: center !important;\n}\n\n.row-attachFiles {\n  width: 100%;\n  margin: 0 !important;\n}\n\nh5 {\n  padding: 0px !important;\n}\n\n.style-btn-2 {\n  background-color: #8f033c !important;\n  color: rgb(255, 255, 255) !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n  align-self: flex-end !important;\n}\n\n.btn-cancel-coi {\n  height: 3rem;\n  margin-top: 10px !important;\n  margin-right: 0 !important;\n}\n\n.col-button-submit {\n  align-self: flex-end;\n  justify-content: flex-end !important;\n  align-items: flex-end !important;\n  align-content: flex-end;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 12px;\n  width: 100%;\n}\n\n.style-btn-1 {\n  background-color: rgb(237, 236, 235) !important;\n  color: black !important;\n  width: 140px !important;\n  padding: 10px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.group-bottom-claim {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  margin-right: 20px;\n}\n\n.title-claim {\n  font-size: 12px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.body-claim {\n  font-size: 11px !important;\n  font-family: \"Lato\", sans-serif !important;\n}\n\nli {\n  font-size: 11px !important;\n  font-family: \"Lato\", sans-serif !important !important;\n}\n\n.icon-file {\n  align-self: center !important;\n  text-align: center !important;\n  margin: 0px 10px !important;\n}\n\n.limit-files {\n  align-self: center !important;\n  text-align: center !important;\n  margin: 0px 0px !important;\n}\n\n@media screen and (max-width: 768px) {\n  .col-button-submit {\n    margin-top: 20px !important;\n  }\n  .box-data-important {\n    height: 100%;\n  }\n}\n@media screen and (max-width: 992px) {\n  .box-data-important {\n    height: 100%;\n  }\n}\ninput[type=file] {\n  display: none;\n}\n\n.custom-file-upload-is-invalid {\n  background-color: rgb(255, 255, 255);\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n  padding-right: calc(1.5em + 0.75rem) !important;\n  border-color: #dc3545;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.custom-file-upload {\n  background-color: rgb(255, 255, 255);\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 5px;\n  width: 100% !important;\n  max-width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ccc;\n  display: block;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.col-button-submit .style-btn-1 {\n  flex: 0 0 auto;\n  width: auto !important;\n  min-width: 110px;\n  max-width: 38%;\n}\n\n.col-button-submit .style-btn-2 {\n  flex: 1 1 auto;\n  width: auto;\n  min-width: 150px;\n  max-width: 60%;\n}\n\n.invalid-feedback-file {\n  color: #dc3545;\n  font-size: 80% !important;\n}\n\n.tooltip-empty {\n  display: none !important;\n}\n\n.btn-delete-it {\n  background-color: #8f033c !important;\n  color: rgb(255, 255, 255) !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n  align-self: flex-end !important;\n}\n\n.btn-cancel-it {\n  background-color: rgb(238, 238, 238) !important;\n  color: black !important;\n  width: 140px;\n  padding: 15px !important;\n  font-size: 10px !important;\n  font-family: \"Lato\", sans-serif !important;\n  align-self: flex-end !important;\n}\n\n.file-clear {\n  color: #8f033c;\n  cursor: pointer;\n}/*# sourceMappingURL=requestcoi.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
